// removed by extract-text-webpack-plugin
module.exports = {"strata":"src-components-Strata----strata-module---strata---1xnFt","content":"src-components-Strata----strata-module---content---3iurR","contentLeft":"src-components-Strata----strata-module---contentLeft---ehmMe","headline":"src-components-Strata----strata-module---headline---1uNMv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Strata/strata.module.scss
// module id = 345
// module chunks = 35783957827783